import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Field, reduxForm } from 'redux-form'
import { push } from 'react-router-redux';

import { tryToUpdateTeamTheme, tryToFetchMyTeams  } from '../../actions/actions.export.js';
import Button from '../Button/Button.js'
import CustomField from '../CustomField/CustomField.js'

// color themes:
var color_themes = [
  '#027CFE', // ct_blue:
  '#EA596E', // ct_pink:
  '#34605C', // ct_green:
  '#3E2B56', // ct_purple:
  '#8C3106', // ct_orange:
  '#808991', // ct_grey:
]

class TeamSettingsThemeForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    var t = props.team.cache[props.id] || {};

    this.state = {
      theme: props.team.updateTeamThemeForm.lastSubmit.theme || t.theme
    }

    this.handleUpdateTeamTheme = this.handleUpdateTeamTheme.bind(this);
  }

  componentWillMount(){
    const { dispatch, team, id } = this.props;

    if(!team.cache[id] || new Date().getTime() - team.cache[id].lastFetch < 2000){
      dispatch(tryToFetchMyTeams());
    }
  }

  componentWillReceiveProps(newprops){
    var t = newprops.team.cache[newprops.id];

    if(!this.state.theme){
      this.setState({
        theme: newprops.team.updateTeamThemeForm.lastSubmit.theme || t.theme
      })
    }
  }

  handleUpdateTeamTheme(e){
    if(e) e.preventDefault();

    const { dispatch, team } = this.props;

    var t = team.cache[this.props.id];

    dispatch(tryToUpdateTeamTheme({
      id: t.id,
      theme: this.state.theme
    }))

  }

  render(){
    const { dispatch, team, user, change } = this.props; 
    const state = this.state;

    var t = team.cache[this.props.id];

    if(!t) return <i className="fal fa-spinner-third fa-spin fa-2x"/>

    let formDisabled = state.theme == t.theme;

    return (
      <div>
        <form onSubmit={(e) => {
          e.preventDefault();
          if(!formDisabled) this.handleUpdateTeamTheme(e);
        }}>

          <CustomField 
            type="text"
            name="theme"
            placeholder="theme"
            description="Enter a hexadecimal color code or choose a preset below."
            label="Theme"
            onChange={(v) => { this.setState({theme: v}); }}
            serverErrors={team.updateTeamNameForm.errors.theme}
            regex="hexadecimal"
            disabled={team.tryingToUpdateTeamName}
          />

          <div className="list-left">
            {
              color_themes.map((c,i)=>{
                return <div 
                  className={"list-item color-swatch " + (this.state.theme === c ? "color-swatch-selected" : "")} 
                  key={i}
                  onClick={(e)=> { 
                    this.setState({ theme: c });
                    setTimeout(()=>{
                      change('theme', c);  
                    });
                    
                  }}
                  >
                  <div className="color-swatch-inner" style={{background: c}}/>
                </div>
              })
            }
            {
              (this.state.theme && color_themes.indexOf(this.state.theme) === -1) && 
              <div className="list-item color-swatch color-swatch-selected">
                <div className="color-swatch-inner" style={{background: this.state.theme}}>
                  <span>custom</span>
                </div>
              </div>
            }
          </div>

          <div className="list-right">
            <Button 
              submit={true} 
              size="medium" 
              disabled={formDisabled} 
              thinking={team.tryingToUpdateTeamTheme} 
              successful={team.successfullyUpdatedTeamTheme}
              failed={team.failedToUpdatedTeamTheme}
              color="success" 
              display="Save Changes" 
            />
          </div>
        </form>
      </div>
    )
  }
}


TeamSettingsThemeForm = reduxForm({
  form: 'TeamSettingsThemeForm',
  enableReinitialize: true,
  destroyOnUnmount: false
})(TeamSettingsThemeForm)

TeamSettingsThemeForm = connect((state, ownProps) => {
  const { team, user } = state;

  var t =  team.cache[ownProps.id];

  var initialValues = {
    theme: t ? t.theme : ''
  };
  
  return {
    team,
    user,
    initialValues
  }
})(TeamSettingsThemeForm);

export default TeamSettingsThemeForm;


// WEBPACK FOOTER //
// ./src/components/TeamSettingsThemeForm/TeamSettingsThemeForm.js